<template>
<div>
    <div
        v-if="title != null"
        style="text-align: center; font-weight: 700; margin-top: 30px; margin-bottom: 15px; font-size: 20px;"
    >
        {{title}}
    </div>

    <Bar
        id="my-chart-id"
        :chartOptions="chart_options"
        :chartData="chart_data"
        style="height: 350px"
    />
    

</div>
</template>

<script>
const _ = require('lodash');
import { Bar } from 'vue-chartjs'
import { Chart as ChartJS, Title, Tooltip, Legend, BarElement, CategoryScale, LinearScale, ArcElement } from 'chart.js'

ChartJS.register(Title, Tooltip, Legend, BarElement, CategoryScale, LinearScale, ArcElement)

export default {
    components: { Bar },

    props: {
        title: {
            type: String,
            default: function() { return "Set title to properly title the chart!"}
        },

        currency: {
            type: Boolean,
            default: function() { return false; }
        },

        labels: {
            type: Array,
            default: function() { return []; }
        },

        data: {
            type: Array,
            default: function() { return []; }
        },
    },

    data() {
        return {
        }
    },

    methods: {
    },

    computed: {
        chart_options() {
            let ret = {
                    responsive: true,
                    maintainAspectRatio: false,
                    scales: {
                        x: 
                        {
                            stacked: true,
                        },
                        y: 
                        {
                            stacked: true,
                        },
                    },
                    plugins: 
                    {
                        tooltip: {
                            callbacks: {
                                label: (context) => {
                                    return (this.currency ? ' $' : ' ')+context.formattedValue;
                                }
                            },
                        },
                    }
                };

               
            if ( this.currency )
            {
                ret.scales.y.ticks = {
                        // Include a dollar sign in the ticks
                        callback: function(value, index, values) {
                            return '$' + value.toLocaleString();
                        }
                    };
            }
            

            return ret;
        },

        chart_data() {
            return {
                'labels': this.labels,
                'datasets': [{
                    'label': this.title,
                    'backgroundColor': 'rgba(241,70,82,0.25)',
                    'data': this.data,
                }],
            };
        },
    },
}
</script>

<style lang="scss" scoped>

</style>